import React from 'react';
import '../styles/Footer.css'
// import call_icon from '../images/call_icon.png';
import mail_icon from '../images/mail_icon.png'

const Footer = () => {

    return (
        <>
        <div className="footer" >
         <div className='line'></div>
         <div className='footer-content'>
            <div className='footer-left'>
                <div className='contactInfo'>Contact Info</div>
                {/* <div className='call_container'>
                    <div className='call_icon'> <img src={call_icon} alt='call_icon' /> </div>
                    <div className='phoneNumber'> -  9876545678</div>
                </div> */}
                <div className='mail_container'>
                    <div className='mail_icon'><img src={mail_icon} alt='mail_icon'/> </div>
                    <div className='email'> -  tto@iiit.ac.in</div>
                </div>
            </div>
         </div>
        </div >  
        </>
    );
}
export default Footer;